
  <div [class]="'modal-dialog' + (config.class ? ' ' + config.class : '')" role="document">
  <div class="modal-content"><ng-content></ng-content></div>
</div>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/free/modals/modalContainer.component.ts.ModalContainerComponent.html